import { render, staticRenderFns } from "./UploadNoteModal.vue?vue&type=template&id=7142ae59&scoped=true"
import script from "./UploadNoteModal.vue?vue&type=script&lang=js"
export * from "./UploadNoteModal.vue?vue&type=script&lang=js"
import style0 from "./UploadNoteModal.vue?vue&type=style&index=0&id=7142ae59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142ae59",
  null
  
)

export default component.exports